var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgClover = function SvgClover(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.44858 1.33301C6.16856 1.33301 7.56385 2.72897 7.56385 4.44794V7.56288H4.44926C2.7286 7.56288 1.33398 6.16522 1.33398 4.44626C1.33398 2.72695 2.7286 1.33301 4.44858 1.33301Z",
    fill: "#228800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.554 1.33301C9.83331 1.33301 8.43802 2.72897 8.43802 4.44794V7.56288H11.5526C13.2739 7.56288 14.6679 6.16522 14.6679 4.44626C14.6679 2.72695 13.2739 1.33301 11.554 1.33301Z",
    fill: "#228800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.43802 11.552C8.43802 13.273 9.83264 14.6669 11.554 14.6669C13.2733 14.6669 14.6679 13.274 14.6679 11.553C14.6679 9.83402 13.2733 8.43704 11.5526 8.43704H8.43802V11.552Z",
    fill: "#228800"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.44791 14.6669C6.16924 14.6669 7.56385 13.273 7.56385 11.552V8.43704H4.44926C2.7286 8.43704 1.33398 9.83402 1.33398 11.553C1.33398 13.274 2.7286 14.6669 4.44791 14.6669ZM6.69036 11.553C6.69036 12.7859 5.68457 13.7887 4.44791 13.7887C3.2126 13.7887 2.20748 12.7859 2.20748 11.553C2.20748 10.3207 3.21395 9.31121 4.45061 9.31121H6.69036V11.553Z",
    fill: "#228800"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgClover);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "clover.0f6edad7229bb9f06aa1cfba8b7c84fb.svg";